export default function SectionHeading({ eyebrow, title, subtitle, align = "left", action }) {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12 ${align === "center" ? "items-center" : ""}`}>
      <div className={`max-w-2xl ${alignCls}`}>
        {eyebrow && <div className="eyebrow mb-3">{eyebrow}</div>}
        <h2 className="font-serif text-4xl md:text-5xl text-ink leading-[1.05] tracking-tight text-balance">{title}</h2>
        {subtitle && <p className="mt-4 text-ink-soft text-base md:text-lg leading-relaxed max-w-xl text-pretty">{subtitle}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
